import { useState, useEffect } from 'react';
import { IconClock } from './Icons';

/**
 * DeadlineWarningModal — shown when jury logs in within 24h of their category's deadline.
 * Displays once per session (tracked via sessionStorage).
 */
const DeadlineWarningModal = ({ deadline, category, onDismiss }) => {
    const [timeLeft, setTimeLeft] = useState('');

    useEffect(() => {
        const update = () => {
            if (!deadline) return;
            const now = new Date();
            const end = new Date(deadline);
            const diff = end - now;

            if (diff <= 0) {
                setTimeLeft('Deadline has passed');
                return;
            }

            const h = Math.floor(diff / (1000 * 60 * 60));
            const m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            const s = Math.floor((diff % (1000 * 60)) / 1000);

            if (h > 0) {
                setTimeLeft(`${h}h ${m}m ${s}s`);
            } else {
                setTimeLeft(`${m}m ${s}s`);
            }
        };

        update();
        const interval = setInterval(update, 1000);
        return () => clearInterval(interval);
    }, [deadline]);

    const deadlineDate = deadline
        ? new Date(deadline).toLocaleString('en-GB', {
            weekday: 'short',
            day: 'numeric',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        })
        : '';

    return (
        <div className="jd-overlay">
            <div className="jd-modal left" style={{ maxWidth: 420 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 16 }}>
                    <div className="jd-deadline-modal-icon">
                        <IconClock size={28} />
                    </div>
                    <div>
                        <div style={{ fontSize: 18, fontWeight: 600, letterSpacing: '-0.02em' }}>
                            Deadline Approaching
                        </div>
                        <div style={{ fontSize: 12, color: 'var(--jd-ink-3)', marginTop: 2 }}>
                            {category}
                        </div>
                    </div>
                </div>

                <div style={{
                    background: 'var(--jd-paper-2)',
                    borderRadius: 8,
                    padding: '16px 18px',
                    marginBottom: 16,
                    border: '1px solid var(--jd-rule)',
                }}>
                    <div className="jd-label" style={{ marginBottom: 8 }}>Time remaining</div>
                    <div style={{
                        fontSize: 28,
                        fontWeight: 600,
                        fontVariantNumeric: 'tabular-nums',
                        letterSpacing: '-0.02em',
                        color: 'var(--jd-err)',
                    }}>
                        {timeLeft}
                    </div>
                    <div style={{ fontSize: 12, color: 'var(--jd-ink-3)', marginTop: 6 }}>
                        Deadline: {deadlineDate}
                    </div>
                </div>

                <p style={{ fontSize: 13, lineHeight: 1.6, color: 'var(--jd-ink-2)', marginBottom: 18 }}>
                    Please ensure all your assessments are submitted before the deadline.
                    Once the scoring period ends, you will no longer be able to submit or edit scores.
                </p>

                <button
                    className="jd-btn primary lg"
                    style={{ width: '100%' }}
                    onClick={onDismiss}
                >
                    I understand, continue
                </button>
            </div>
        </div>
    );
};

export default DeadlineWarningModal;
